const advancedColorKeyToVariableKey = (colorKey) =>
  colorKey.replace('NavLink', 'MNavLink').replace('Color', '').concat('Color');

export default advancedColorKeyToVariableKey;
